import {
    apiRequest,
    organizationList,
    organizationActive,
    organizationInactive
} from "../../../../../services/adapters/kepegawaian/organizationhistoriService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", organizationList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", organizationInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", organizationActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository